import { Box, Button, Typography } from "@mui/material";
import React from "react";
import EastIcon from '@mui/icons-material/East';

const CustomButton = ({ buttonText, onClick, variant, isSubmit, padding }) => {
  const isOutlined = variant === "outlined";

  return (
    <Button
      onClick={onClick}
      type={isSubmit ?? "submit"}
      sx={{
        bgcolor: isOutlined ? "transparent" : "red.main",
        borderRadius: "8px",
        p: padding || "5px 10px",
        textTransform: "capitalize",
        border: isOutlined ? "1px solid #DC143C" : "none",
      }}
    >
      <Typography variant="body2" sx={{ color: isOutlined ? "red.main" : "primary.main", }}>{buttonText}</Typography>
    </Button>
  );
};

export const CustomButtonContained = (props) => (
  <CustomButton {...props} variant="contained" />
);

export const CustomButtonOutline = (props) => (
  <CustomButton {...props} variant="outlined" />
);

export const LightButton = ({ icon, text, onClick }) => {
  return (
    <Button onClick={onClick} startIcon={icon} sx={{ border: "1px solid #D9D9D9", borderRadius: "12px", padding: "5px 10px", textTransform: "capitalize", }}><Typography variant="body1">{text}</Typography></Button>
  )
}

export const NavigateButton = ({ onClick }) => {
  return (
    <Box display={"flex"} justifyContent={"center"}>
      <Button variant='outlined' style={{ borderRadius: "50px", backgroundColor: "#fff" }} onClick={onClick}>see all</Button>
    </Box>
  )
}

export const KnowMoreButton = ({ text, onClick }) => {
  return (
    <Button

      style={{
        backdropFilter: "blur(8px)",
        background: "linear-gradient(271.59deg, rgba(255, 255, 255, 0.3) 2.66%, rgba(255, 255, 255, 0.8) 95.01%)",
        borderRadius: "40px", color: "#000", fontSize: "16px",
        fontWeight: "400",
        lineHeight: "25px",
        p: "5px 15px",
        marginBottom: "15px",
        width: "50%",
        border: "none"
      }}
      endIcon={<EastIcon />}
      variant="outlined" onClick={onClick}>
      {text}
    </Button>
  )
}
